export default __webpack_public_path__ + "static/media/havells-h-logo.a0cfe24a.svg";